import { useQuery } from 'react-query'
import { ContentDefaultsClient } from 'api/clients/ContentDefaultsClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ContentDefaults } from 'types'

const fetchContentDefaults = async (): Promise<ContentDefaults> => {
  const response = await ContentDefaultsClient.getContentDefaults()

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to fetch content defaults')
  }

  return response.data
}

export const useContentDefaults = () => {
  return useQuery<ContentDefaults>(['content_defaults'], fetchContentDefaults, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
